import comp from "./QuestionsCount";
export default comp;
